/* jshint esnext:true */

import {csrfToken} from 'mk/common/csrfToken';
import {ERROR_CODES} from 'mk/bazaar/common/enums';

let apiAuthCsrfToken = csrfToken();

const apiAuthVerifier = () => {
    // we check if the csrf-token has changed
    // since page-load. this can happen
    // for example when the user re-logins
    // in an another browser-tab
    // and then returns to this tab
    const currentCsrfToken = csrfToken();
    if (currentCsrfToken !== apiAuthCsrfToken) {
        const err = new Error('apiStatus verification failed');
        err.errorCode = ERROR_CODES.CSRF_CHANGED_ERROR;
        throw err;
    }
};

export function makeClientApiAuth() {
    const ssrRequestIdMeta = document.querySelector('meta[name="mk:ssr-request-id"]');
    return {
        verifier: apiAuthVerifier,
        baseUrl: '', // we could use also http://www.modrykonik.sk
        cookies: [],
        headers: [
            ['X-CSRFToken', apiAuthCsrfToken],
            ['X-SSR-Request-Id', ssrRequestIdMeta ? ssrRequestIdMeta.content : 'unknown'],
        ],
    };
}

export function refreshApiAuthCsrfToken() {
    apiAuthCsrfToken = csrfToken();
}
